import { Link } from "react-router-dom";

export default function FooterOne() {
    return (
        <div
            style={{
                width: "100%",
                background: "#ffffff",
                color: "#000000",
                padding: "60px 0 40px",
                fontFamily: "Inter, sans-serif",
            }}
        >
            {/* INLINE STYLES */}
            <style>{`
                a {
                    color: inherit !important;
                    text-decoration: none !important;
                    transition: 0.3s ease;
                }
                a:hover {
                    opacity: 0.6 !important;
                }
                .footer-grid {
                    display: grid;
                    grid-template-columns: repeat(auto-fit, minmax(220px, 1fr));
                    gap: 50px;
                    width: 90%;
                    max-width: 1400px;
                    margin: 0 auto;
                    text-align: left;
                }
                .footer-title {
                    font-size: 20px;
                    font-weight: 600;
                    margin-bottom: 16px;
                    color: #111;
                }
                .footer-linklist li {
                    margin-bottom: 10px;
                    font-size: 15px;
                    opacity: 0.85;
                }
                .footer-linklist li:hover {
                    opacity: 1;
                }
                .social-icons {
                    display: flex;
                    gap: 12px;
                    margin-top: 12px;
                }
                .social-btn {
                    width: 44px;
                    height: 44px;
                    border-radius: 50%;
                    display: flex;
                    align-items: center;
                    justify-content: center;
                    background: #f3f3f3;
                    color: #000;
                    font-size: 20px;
                    transition: 0.3s ease;
                    border: 1px solid #e0e0e0;
                }
                .footer-bottom {
                    width: 90%;
                    max-width: 1400px;
                    margin: 40px auto 0;
                    padding-top: 20px;
                    border-top: 1px solid #e5e5e5;
                    text-align: center;
                    font-size: 14px;
                    opacity: 0.7;
                }
            `}</style>

            {/* MAIN FOOTER GRID */}
            <div className="footer-grid">

                {/* Logo + Description */}
                <div>
                    <img
                        src="assets/images/logo/logo1.png"
                        alt="logo"
                        style={{ width: "170px", marginBottom: "18px" }}
                    />
                    <p style={{ fontSize: "15px", lineHeight: "24px", opacity: 0.8 }}>
                        Premium quality products with trusted customer service.
                        We aim to deliver excellence in every step.
                    </p>

                    {/* Social Icons */}
                    <div className="social-icons">
                        <Link className="social-btn" to="#"><i className="ph-fill ph-facebook-logo" /></Link>
                        <Link className="social-btn" to="#"><i className="ph-fill ph-twitter-logo" /></Link>
                        <Link className="social-btn" to="#"><i className="ph-fill ph-instagram-logo" /></Link>
                        <Link className="social-btn" to="#"><i className="ph-fill ph-linkedin-logo" /></Link>
                    </div>
                </div>

                {/* Contact */}
                <div>
                    <h4 className="footer-title">Contact Info</h4>
                    <p style={{ fontSize: "15px", lineHeight: "22px", opacity: 0.85 }}>
                        Durga Enterprise<br />
                        FF 52, Earth Eon, Opposite Urmi School,<br />
                        Sama-Savli Road, Vadodara - 390022
                    </p>
                    <Link to="tel:+916359667777" style={{ display: "block", fontSize: "15px", marginTop: "5px" }}>
                        +91 63596 67777
                    </Link>
                    <Link to="mailto:info@durgaenterpriseglobal.com" style={{ display: "block", fontSize: "15px", marginTop: "5px" }}>
                        info@durgaenterpriseglobal.com
                    </Link>
                </div>

                {/* Information / Terms */}
                <div>
                    <h4 className="footer-title">Information</h4>
                    <ul className="footer-linklist">
                        <li><Link to="/about-us">About Us</Link></li>
                        <li><Link to="/contact-us">Contact Us</Link></li>
                        <li><Link to="/terms-conditions">Terms & Conditions</Link></li>
                        <li><Link to="/privacy-policy">Privacy Policy</Link></li>
                        <li><Link to="/shipping-policy">Shipping Policy</Link></li>
                        <li><Link to="/refund-policy">Refund Policy</Link></li>
                        <li><Link to="/cancellation-policy">Cancellation Policy</Link></li>
                    </ul>
                </div>
            </div>

            {/* FOOTER BOTTOM */}
            <div className="footer-bottom">
                © {new Date().getFullYear()} Durga Enterprise. All Rights Reserved.
            </div>
        </div>
    );
}
